// extracted by mini-css-extract-plugin
module.exports = {"list":"list--14vBT","item":"item--2Mbln","titleimg":"titleimg--QE5hl","shade":"shade--vEJWa","descwrap":"descwrap--H5IL4","readNum":"readNum--2DwFM","title":"title--lFfML"};